const statusColors = {
  // Order Status Colors (New workflow)
  ready_for_packaging: { bg: "bg-blue-100", text: "text-blue-800" },
  on_hold: { bg: "bg-yellow-100", text: "text-yellow-800" },
  ready_for_shipping: { bg: "bg-indigo-100", text: "text-indigo-800" },
  shipped: { bg: "bg-green-100", text: "text-green-800" },
  ship_partially: { bg: "bg-orange-100", text: "text-orange-800" },
  handed_off: { bg: "bg-gray-100", text: "text-gray-800" },
  delivered: { bg: "bg-emerald-100", text: "text-emerald-800" },
  canceled: { bg: "bg-red-100", text: "text-red-800" },

  // Legacy Order Status Colors (for backward compatibility)
  new: { bg: "bg-blue-100", text: "text-blue-800" },
  assigned: { bg: "bg-orange-100", text: "text-orange-800" },
  in_progress: { bg: "bg-yellow-100", text: "text-yellow-800" },
  paid: { bg: "bg-purple-100", text: "text-purple-800" },

  // Payment Status Colors
  completed: { bg: "bg-green-100", text: "text-green-800" },
  pending: { bg: "bg-yellow-100", text: "text-yellow-800" },
  failed: { bg: "bg-red-100", text: "text-red-800" },
  processing: { bg: "bg-blue-100", text: "text-blue-800" },

  // User Status Colors
  active: { bg: "bg-green-100", text: "text-green-800" },
  deactivated: { bg: "bg-red-100", text: "text-red-800" },

  // Default
  default: { bg: "bg-gray-100", text: "text-gray-800" },
} as const;

export const getStatusColors = (status: string) => {
  const key = status
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "_") as keyof typeof statusColors;
  return statusColors[key] || statusColors.default;
};

export default statusColors;
